import { render, staticRenderFns } from "./HeaDers.vue?vue&type=template&id=4ac13df0&scoped=true&"
import script from "./HeaDers.vue?vue&type=script&lang=js&"
export * from "./HeaDers.vue?vue&type=script&lang=js&"
import style0 from "./HeaDers.vue?vue&type=style&index=0&id=4ac13df0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac13df0",
  null
  
)

export default component.exports